import EDataTable4 from './EDataTable4'

export default EDataTable4
